/**
 * magenta colors by number from the lightest to the darkest
 */
export var magenta01 = '#dcacff';
export var magenta02 = '#c377f9';
export var magenta03 = '#9c40df';
export var magenta04 = '#5f0e99';
